import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71c723da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "page-path path-links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_4 = { class: "page-title types" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "not-found c-secondary"
}
const _hoisted_8 = {
  key: 1,
  class: "page-title"
}
const _hoisted_9 = {
  key: 2,
  class: "type1"
}
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "option" }
const _hoisted_14 = { class: "option" }
const _hoisted_15 = { class: "desc-c" }
const _hoisted_16 = { class: "desc line3" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "found"
}
const _hoisted_20 = { class: "btns" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-bofang" }, null, -1))
const _hoisted_24 = {
  key: 3,
  class: "type2"
}
const _hoisted_25 = { class: "tr head" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 4,
  class: "type3"
}
const _hoisted_29 = { class: "item" }
const _hoisted_30 = { class: "info" }
const _hoisted_31 = { class: "name" }
const _hoisted_32 = { class: "desc-c" }
const _hoisted_33 = { class: "desc line4" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "movies" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "popup" }

import movieSearch, { State } from '@/store/movies/search';
import Avatar from '@/views/components/Avatar.vue';
import MoreText from '@/views/components/MoreText.vue';
import Pagination from '@/views/components/Pagination.vue';
import Poster from '@/views/components/Poster.vue';
import * as links from '@/views/links';
import ViewContext from '@/views/ViewContext';
import { computed, inject, onBeforeUnmount, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Album from '../albums/Album.vue';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const context = inject('context') as ViewContext;
const store = useStore();
const data = computed<State>(() => store.state[movieSearch.name])
const list = computed(() => data.value.albums.slice(0, data.value.pageSize))
const container = ref<HTMLDivElement>()

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

const state = reactive({
    moreVisible: false,
    moreContent: '',
})
onBeforeUnmount(() => {
    window.onresize = null
    movieSearch.clearSearch(store);
})

function onPageChange(page: number) {
    const query = Object.assign({ kw: data.value.keywords }, { page: page, type: data.value.type, })
    context.go(query)
}

function onType(value: string) {
    const query = Object.assign({ kw: data.value.keywords }, { type: value, page: data.value.page })
    context.go(query)
}

function searchText(value: string) {
    value = value.replace(/<.+?>/g, '')
    return value.replace(new RegExp('(' + data.value.keywords + ')', 'g'), '<label class="kw">$1</label>')
}
function onMovie(item: any) {
    router.push(links.album(item.movid))
}
function onVideo1(item: any) {
    if (item.video) {
        router.push(links.player(item.movid, item.video.urlid))
    } else {
        router.push(links.player(item.movid))
    }
}
function onVideo2(item: any) {
    router.push(links.player(item.movid, item.urlid))
}
function onAuthor(item: any) {
    router.push(links.author(item.id))
}
function onShowMore(value: string) {
    state.moreContent = value
    state.moreVisible = true
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "link",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(lang).topMenu.movie), 1)
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == '1' }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onType('1')))
      }, _toDisplayString(_unref(lang).movieText.search_album), 3),
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == '2' }),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onType('2')))
      }, _toDisplayString(_unref(lang).movieText.search_video), 3),
      _createElementVNode("a", {
        class: _normalizeClass({ on: _unref(data).type == '3' }),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (onType('3')))
      }, _toDisplayString(_unref(lang).movieText.search_author), 3)
    ]),
    (_unref(data).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(lang).movieText.search_loading), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_unref(data).total == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(lang).movieText.search_notfound), 1))
            : _createCommentVNode("", true),
          (_unref(data).total == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("b", null, _toDisplayString(_unref(lang).movieText.search_recommend), 1)
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == 1 && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(Poster, {
                      class: "poster",
                      url: item.thumb
                    }, null, 8, ["url"]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: "title",
                        innerHTML: searchText(item.title)
                      }, null, 8, _hoisted_12),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.language) + " | " + _toDisplayString(item.source), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(lang).movieText.search_album_author) + "： " + _toDisplayString(item.speaker), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_unref(lang).movieText.search_album_intro) + "： ", 1),
                          _createElementVNode("span", {
                            innerHTML: searchText(item.content)
                          }, null, 8, _hoisted_17),
                          _createElementVNode("a", {
                            class: "more",
                            onClick: ($event: any) => (onShowMore(item.content))
                          }, _toDisplayString(_unref(lang).movieText.search_more), 9, _hoisted_18)
                        ])
                      ]),
                      (item.video)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_unref(lang).movieText.search_album_found) + "：", 1),
                            _createElementVNode("label", null, _toDisplayString(item.video.seo_title), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "detail",
                          onClick: ($event: any) => (onMovie(item))
                        }, _toDisplayString(_unref(lang).movieText.search_album_detail), 9, _hoisted_21),
                        _createElementVNode("a", {
                          class: "play",
                          onClick: ($event: any) => (onVideo1(item))
                        }, [
                          _hoisted_23,
                          _createTextVNode(_toDisplayString(_unref(lang).movieText.search_album_play), 1)
                        ], 8, _hoisted_22)
                      ])
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == 2 && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search_list_no), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search_list_title), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search_list_album), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.search_list_author), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item, i) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "tr",
                    onClick: ($event: any) => (onVideo2(item))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(data).page * _unref(data).pageSize + i + 1), 1),
                    _createElementVNode("span", {
                      innerHTML: searchText(item.seo_title)
                    }, null, 8, _hoisted_27),
                    _createElementVNode("span", null, _toDisplayString(item.movie.title), 1),
                    _createElementVNode("span", null, _toDisplayString(item.movie.speaker), 1)
                  ], 8, _hoisted_26))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).type == '3' && _unref(data).total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).albums, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createVNode(Avatar, {
                      url: item.thumb
                    }, null, 8, ["url"]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("span", {
                            innerHTML: searchText(item.content)
                          }, null, 8, _hoisted_34),
                          _createElementVNode("a", {
                            class: "more",
                            onClick: ($event: any) => (onShowMore(item.content))
                          }, _toDisplayString(_unref(lang).movieText.search_more), 9, _hoisted_35)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("a", {
                          class: "all",
                          onClick: ($event: any) => (onAuthor(item))
                        }, _toDisplayString(_unref(lang).movieText.search_author_detail), 9, _hoisted_37),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items.slice(0, 5), (movie) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: "movie-item",
                            onClick: ($event: any) => (onMovie(movie))
                          }, [
                            _createVNode(Poster, {
                              url: movie.thumb
                            }, null, 8, ["url"]),
                            _createElementVNode("div", _hoisted_39, _toDisplayString(movie.title), 1)
                          ], 8, _hoisted_38))
                        }), 256))
                      ])
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          (_unref(data).total == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "albums",
                ref_key: "container",
                ref: container
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
                  return (_openBlock(), _createBlock(Album, { album: item }, null, 8, ["album"]))
                }), 256))
              ], 512))
            : _createCommentVNode("", true),
          _createVNode(Pagination, {
            total: _unref(data).total,
            page: _unref(data).page,
            size: _unref(data).pageSize,
            onChange: onPageChange
          }, null, 8, ["total", "page", "size"])
        ])),
    (_unref(state).moreVisible)
      ? (_openBlock(), _createBlock(MoreText, {
          key: 2,
          content: _unref(state).moreContent,
          theme: "light",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_unref(state).moreVisible = false))
        }, null, 8, ["content"]))
      : _createCommentVNode("", true)
  ]))
}
}

})